import DOMPurify from 'dompurify';

const sanitizeHTML = (content) => {
	return DOMPurify.sanitize(content, {
		ADD_ATTR: ['target', 'rel'],
	});
};

export default sanitizeHTML;
